import { render, staticRenderFns } from "./mc-taken-over-prompt.vue?vue&type=template&id=0448215b&scoped=true"
import script from "./mc-taken-over-prompt.vue?vue&type=script&lang=ts"
export * from "./mc-taken-over-prompt.vue?vue&type=script&lang=ts"
import style0 from "./mc-taken-over-prompt.vue?vue&type=style&index=0&id=0448215b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0448215b",
  null
  
)

export default component.exports